<template>
  <ChipList
    :item="{items: processes_list}"
    :disable="disable"
    @update="chip_clicked"
  ></ChipList>
</template>
  
  
<script>
  import { mapState } from 'vuex';
  
  export default {
    name: 'ProcessesChip',
  
    props: {
      item: {type: Object},
      disable: {
        type: Boolean,
        default: false,
      },
    },
  
    components: {
      ChipList: () => import('@/components/explorer/chips/ChipList'),
    },
  
    data: () => ({
      gaa: null,
    }),
  
    computed: {
      ...mapState(['allProcesses']),
      processes_list() {
        return this.item.value.map(itm => ({
                                    component: 'ChipGeneric',
                                    name: 'process_'+itm,
                                    readable:  this.$vuetify.lang.translator('chips.process'),
                                    value: itm,
                                    readableValue: this.getProcessName(itm),
                                    }))
      },
    },
  
    methods: {
      getProcessName(item) {
        let process = this.allProcesses.find(prc => prc.id === item);
        if (process) {
          return process.name;
        } else {
          return item;
        }
      },
      chip_clicked(selected_item){
        let new_item = this.item;
        new_item['selected'] = [selected_item.value];
        new_item['type'] = 'array';
        this.$emit('update',new_item);
      },    
    },
  }
</script>